import { useEffect, useState } from "react";

export const useGoogleAuth = () => {
    const [url, setUrl] = useState("");
    const [redirectAfterGoogleLogin, setRedirectAfterGoogleLogin] = useState("");

    useEffect(() => {
        setRedirectAfterGoogleLogin(window.history.state.redirect);
        const client_id =
          "58955581394-di269jc3f250g92ndunslbnklofspi5t.apps.googleusercontent.com";
        const scope = "openid email profile";
        const redirect_uri = `https://digitoon.tv/callback/`;// `${window.location.protocol}//${window.location.hostname}/callback/`;
        const response_type = "token id_token";
        const state = localStorage.getItem("state");
        const googleUrl = `https://accounts.google.com/o/oauth2/auth?scope=${scope}&client_id=${client_id}&redirect_uri=${redirect_uri}&response_type=${response_type}&state=${state}`;
        setUrl(googleUrl);
    }, []);

    return {url, redirectAfterGoogleLogin};
};